import BrandLockup from './BrandLockup';

function ScreenHeader({ title, subtitle, action }) {
  return (
    <header className="screenHeader">
      <BrandLockup title={title} subtitle={subtitle} />
      {action ? <div className="screenHeader__action">{action}</div> : null}
    </header>
  );
}

export default ScreenHeader;
